import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { FirebaseApp } from 'firebase/app';
import { connectAuthEmulator, User } from 'firebase/auth';

import FirebaseAuth from './FirebaseAuth';

import { getAuth } from '../../util';
import { logger } from 'services/Logger';

class FirebaseEmulatorAuth extends FirebaseAuth {
  onSetUser: null | ((token: string) => void) = null;

  constructor(app: FirebaseApp) {
    super(app);
    const auth = getAuth(app);
    const host = process.env.REACT_APP_HOST ?? 'localhost';
    const port = 9099;

    try {
      connectAuthEmulator(auth, `http://${host}:${port}`, {
        disableWarnings: true,
      });

      // Capacitor Firebase Authentication Emulator
      // eslint-disable-next-line react-hooks/rules-of-hooks
      FirebaseAuthentication.useEmulator({
        host: `${host}:${port}`,
        port: port,
      });
    } catch (error) {
      logger.warn('Auth Emulator connection failed:', error);
    }
  }

  protected setUser(result: User, isNewUser: boolean) {
    if (!result) return;
    if ((result as unknown as any)?.accessToken) {
      this.onSetUser?.((result as unknown as any).accessToken);
      super.setUser(result, isNewUser);
    } else {
      FirebaseAuthentication.getIdToken().then((token) => {
        this.onSetUser?.(token.token);
        super.setUser(result, isNewUser);
      });
    }
  }
}

export default FirebaseEmulatorAuth;
